import React from 'react';
import { GoogleMap,Marker, useJsApiLoader } from '@react-google-maps/api';
const Map = () => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyA5VYwvKIBZGItsDGwY3sZqUUq3eamxfiQ',
    });
    if (!isLoaded) {
        return <div>Loading...</div>;
    }
    const center = { lat: 21.113502502441406, lng: 79.03509521484375 };
    return (
        <GoogleMap
            mapContainerStyle={{ width: '100%', height: '360px', borderRadius:'10px'}}
            center={center}
            zoom={15} // Adjusted for better marker visibility
        >
            <Marker position={center} />
        </GoogleMap>
    );
};
export default Map;
